import { TutorialsIcon } from "../../../modules/Icons"
import { AcademyHeaderProps } from "../../../types/components/academy/indexPage/AcademyHeader"

export const sectionClass = "w-full h-[260px] px-[40px] flex flex-col gap-2 lg:gap-4 items-center lg:items-start justify-center rounded-[5px] mb-[16px] relative overflow-hidden"
export const headerClass = "eurostile uppercase text-[36px] !font-semibold leading-[48px] relative z-10"
export const descriptionClass = "max-w-[626px] text-gray-500 text-center lg:text-start text-12 lg:text-16 relative z-10"

export const iconContainerClass = "flex gap-6 pt-2 text-a-light-gray text-14 relative z-10"
export const iconClass = "inline w-[24px] stroke-a-light-gray"

const AcademyHeader: React.FC<AcademyHeaderProps> = ({ tutorialsTotal }) => {
  return (
    <section
      cy-test-id="academy-header"
      className={sectionClass}
    >
      <video
        className="absolute inset-0 z-0 object-cover w-full h-full"
        preload="auto"
        autoPlay
        loop={true}
        muted
        poster={'https://cms.actionvfx.com/rails/active_storage/blobs/eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaHBHUT09IiwiZXhwIjpudWxsLCJwdXIiOiJibG9iX2lkIn19--bb753a1f322d9e5ccaae643a14846e41795171df/Front_page_static_banner.jpg'}
      >
        <source src="https://a-us.storyblok.com/f/1002378/x/cc6a51c98d/about-us-montage-v2.mp4" />
      </video>

      <div cy-test-id="academy-header-overlay" className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/40 to-transparent z-5"></div>

      <div cy-test-id="academy-header" className={headerClass}>Academy</div>
      <span className={descriptionClass}>Access our growing library of tutorials, courses, and other resources to help you become a better VFX artist.</span>

      <div cy-test-id="academy-header-icon" className={iconContainerClass}>
        <span><TutorialsIcon className={iconClass} /> {tutorialsTotal} Tutorials</span>
      </div>
    </section>
  )
}

export default AcademyHeader;